import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#f6c51c",
        secondary: "#BDBDBD",
        accent: "#ff5722",
        error: "#d32f2f",
        info: "#1976d2",
        success: "#388e3c",
        warning: "#ffa000",
      },
    },
  },
});

export default vuetify;
